export const InventoryListColConfig = [

  {
    name_of_db_column: "productId",
    label_of_column: "PRODUCT ID",
    order_of_column: 1,
  },
  {
    name_of_db_column: "warehouseId",
    label_of_column: "WAREHOUSE ID",
    order_of_column: 2,
  },
  {
    name_of_db_column: "productCategory",
    label_of_column: "PRODUCT CATEGORY",
    order_of_column: 3,
  },
  {
    name_of_db_column: "gtin",
    label_of_column: "GTIN",
    order_of_column: 4,

  },
  {
    name_of_db_column: "stock",
    label_of_column: "STOCK",
    order_of_column: 5,
  },
  {
    name_of_db_column: "daysOnStock",
    label_of_column: "DAYS ON STOCK",
    order_of_column: 5,
  },
  {
    name_of_db_column: "modificationDate",
    label_of_column: "MODIFICATION DATE",
    order_of_column: 6,
    filterVariant: 'date',
    initialSize: 330,
  },
]
